import { render, staticRenderFns } from "./SubmissionReviewFormRatingsSimple.vue?vue&type=template&id=dcc6e96a&scoped=true&"
import script from "./SubmissionReviewFormRatingsSimple.vue?vue&type=script&lang=js&"
export * from "./SubmissionReviewFormRatingsSimple.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionReviewFormRatingsSimple.vue?vue&type=style&index=0&id=dcc6e96a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc6e96a",
  null
  
)

export default component.exports